var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWheelPantry(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 25,
    viewBox: "0 0 26 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.9766 12.5C24.9766 10.9241 24.6662 9.36371 24.0631 7.9078C23.4601 6.45189 22.5761 5.12902 21.4618 4.01472L17.803 7.67357C18.4368 8.30739 18.9396 9.05984 19.2826 9.88796C19.6256 10.7161 19.8022 11.6036 19.8022 12.5H24.9766Z",
    stroke: "#565556"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.4618 4.01472C19.2114 1.76428 16.1592 0.5 12.9766 0.5L12.9766 5.6744C14.7868 5.6744 16.5229 6.39352 17.803 7.67357L21.4618 4.01472Z",
    stroke: "#565556"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24.9766 12.5C24.9766 15.6826 23.7123 18.7348 21.4618 20.9853L17.8028 17.3262C19.0827 16.0462 19.8018 14.3102 19.8018 12.5H24.9766Z",
    stroke: "#565556"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M21.4618 20.9853C19.2114 23.2357 16.1592 24.5 12.9766 24.5L12.9766 19.3256C14.7868 19.3256 16.5229 18.6065 17.803 17.3264L21.4618 20.9853Z",
    stroke: "#565556"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M12.9766 24.5C9.79396 24.5 6.74172 23.2357 4.49128 20.9853L8.15013 17.3264C9.43018 18.6065 11.1663 19.3256 12.9766 19.3256L12.9766 24.5Z",
    stroke: "#565556"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M4.49128 20.9853C3.37698 19.871 2.49306 18.5481 1.89001 17.0922C1.28695 15.6363 0.976562 14.0759 0.976562 12.5L6.15096 12.5C6.15096 13.3964 6.32751 14.2839 6.67053 15.112C7.01355 15.9402 7.51632 16.6926 8.15013 17.3264L4.49128 20.9853Z",
    stroke: "#565556"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M0.976562 12.5C0.976563 9.3174 2.24084 6.26516 4.49128 4.01472L8.15013 7.67357C6.87009 8.95362 6.15096 10.6897 6.15096 12.5L0.976562 12.5Z",
    stroke: "#565556"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M4.49128 4.01472C5.60558 2.90042 6.92845 2.0165 8.38436 1.41345C9.84027 0.810389 11.4007 0.5 12.9766 0.5L12.9766 5.6744C12.0802 5.6744 11.1926 5.85095 10.3645 6.19397C9.5364 6.53699 8.78395 7.03976 8.15013 7.67357L4.49128 4.01472Z",
    stroke: "#565556"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWheelPantry);
export default __webpack_public_path__ + "static/media/WheelPantry.c6f42e9805ae58fbd73bbc5d37c5a5d5.svg";
export { ForwardRef as ReactComponent };